<!-- src/pages/MyPage.vue -->
<script setup>
import { useRouter } from 'vue-router';
import MobileHeader from '@/components/common/MobileHeader.vue';
import InquiryWriteComponent from '@/components/board/BoardWriteInquiry.vue';

definePage({ meta: { layout: 'manse' } });

const router = useRouter();

// 뒤로가기 핸들러
const handleBack = () => {
	router.back();
};
</script>

<template>
  <div class="wide-wrap">
    <MobileHeader title="문의하기" :show-back="false" :show-menu="true" @back="handleBack" />
    <div class="inner-wrap">
      <div class="my-info-wrap">
        <div class="my-tit-box com-bg-my-box h-small st-guest">
          <div class="tit fnt-big">문의하기</div>
          <div class="path">
            문의하신 내용은 휴대폰 번호(sms) 또는 이메일(e-mail) 로 안내드리고 있습니다.
          </div>
        </div>
        <InquiryWriteComponent />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.mypage-body .board-inquiry-box {
  display: none;
}
.mypage-body .board-tit-box {
  display: none;
}

// 반응형: 1024px 이하
@media (max-width: 1024px) {
  .wide-wrap {
    padding: 0 0 60px 0;
    padding-top: 52px; // 헤더 높이만큼 상단 패딩 추가

    .inner-wrap {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }

  .my-info-wrap {
    width: 100% !important;
    max-width: 100% !important;

    .my-tit-box {
      width: 100% !important;
      max-width: 100% !important;
      padding: 20px 16px !important;
      box-sizing: border-box;
      margin-top: 0 !important;

      .tit {
        font-size: 18px !important;
        display: none; // 반응형에서는 헤더에 타이틀이 있으므로 숨김
      }

      .path {
        font-size: 13px !important;
        line-height: 18px !important;
        margin-top: 8px;
      }
    }
  }
}
</style>
